export default String.raw`
{% assign coupon = customer-profile.CouponDetails -%}
{% if include -%}
	{% assign elementsParent = include -%}
{% else -%}
	{% assign elementsParent = coupon -%}
{% endif -%}

<div class="eshop__table-container coupon-elements-table-js">
	{% assign anyGroup = false -%}
	{% assign anyProduct = false -%}
	{% assign anyMinValue = false -%}
	{% assign anyQuantity = false -%}
	{% for element in elementsParent.Groups -%}
		{% assign anyGroup = true -%}
	{% endfor -%}
	{% for element in elementsParent.Products -%}
		{% assign anyProduct = true -%}
	{% endfor -%}
	{% if elementsParent.ProductsMinimumTotalValue > 0 -%}
		{% assign anyMinValue = true -%}
	{% endif -%}
	<table>
		<colgroup>
			<col style="width:130px">
			<col style="width:80px">
		{% if anyMinValue -%}
			<col style="width:80px">
		{% endif -%}
		</colgroup>
        <div class="products-table-header-js">
			<thead>
				<tr class="products-table-header-container-js">
					<th class="id name-and-code-js">
						{% if anyGroup and anyProduct -%}
							{{translations.Product}}/{{translations.Category}}
						{% elseif anyGroup -%}
							{{translations.Category}}
						{% else -%}
							{{translations.Product}}
						{% endif -%}
					</th>
					<th class="price-like-column-js prices-view-js">
						{{translations.Value}}
					</th>
					{% if anyMinValue -%}
					<th class="price-like-column-js prices-view-js">
						{{translations.MinimumValue}}
					</th>
					{% endif -%}
				</tr>
			</thead>
        </div>
		<tbody>
		{% if anyGroup -%}
			{% for group in elementsParent.Groups -%}
			{% assign index = forloop.index -%}
			{% if index == 1 -%}
			<script>
				if(typeof gtag != 'undefined'){
					gtag("event", "view_promotion", {
						promotion_name: '{% if coupon.Code != null -%}{{ coupon.Code }}{% else -%}{{ translations.Coupons }}{% endif -%}',
						items: [{ item_id: '{{ group.Id }}', item_name: '{{ group.Name }}' }]
					});
				}
			</script>
			{% endif -%}
            <tr class="cart-product-container-js">
				<td class="product-cell name-and-code-js">
					<span class="product-name id">
						{% if group.Url -%}
							<a class="select-coupon-js" href="{{ page.BaseHref }}{{ group.Url }}" data-name="{% if coupon.Code != null -%}{{ coupon.Code }}{% else -%}{{ translations.Coupons }}{% endif -%}">
						{% endif -%}
								{{ group.Name }}
						{% if group.Url -%}
							</a>
						{% endif -%}
					</span>
				</td>
				<td class="prices-view-js">
					{% if coupon.Type == 0 -%}
						{{coupon.Discount | Normalize}} %
					{% elseif coupon.Type == 1 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 2 -%}
						{{translations.FreeDelivery}}
					{% elseif coupon.Type == 3 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 4 -%}
						{{coupon.Discount | Normalize}} %
					{% endif -%}
				</td>
				{% if anyMinValue -%}
				<td class="prices-view-js">
					{{ coupon.ProductsMinimumTotalValue | ToPrice }} {{currencyExt}}
				</td>
				{% endif -%}
			</tr>
			{% endfor -%}
		{% endif -%}
		{% if anyProduct -%}
			{% for product in elementsParent.Products -%}
			{% assign index = forloop.index -%}
			{% if index == 1 and anyGroup == false -%}
			<script>
				if(typeof gtag != 'undefined'){
					gtag("event", "view_promotion", {
						promotion_name: '{% if coupon.Code != null -%}{{ coupon.Code }}{% else -%}{{ translations.Coupons }}{% endif -%}',
						items: [{ item_id: '{{ product.Id }}', item_name: '{{ product.NameNoHtml }}' }]
					});
				}
			</script>
			{% endif -%}
            <tr class="cart-product-container-js">
				<td class="product-cell name-and-code-js">
					<span class="product-name id">
						{% if product.Url -%}
							<a class="select-coupon-js" href="{{ page.BaseHref }}{{ product.Url }}" data-name="{% if coupon.Code != null -%}{{ coupon.Code }}{% else -%}{{ translations.Coupons }}{% endif -%}">
						{% endif -%}
								{{ product.NameNoHtml }}
						{% if product.Url -%}
							</a>
						{% endif -%}
					</span>
				</td>
				<td class="prices-view-js">
					{% if coupon.Type == 0 -%}
						{{coupon.Discount | Normalize}} %
					{% elseif coupon.Type == 1 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 2 -%}
						{{translations.FreeDelivery}}
					{% elseif coupon.Type == 3 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 4 -%}
						{{coupon.Discount | Normalize}} %
					{% endif -%}
				</td>
				{% if anyMinValue -%}
				<td class="prices-view-js">
					{{ coupon.ProductsMinimumTotalValue | ToPrice }} {{currencyExt}}
				</td>
				{% endif -%}
			</tr>
			{% endfor -%}
		{% endif -%}
		{% if anyGroup == false and anyProduct == false -%}
			<tr class="cart-product-container-js">
				<td class="product-cell name-and-code-js">
					<span class="product-name id">
						{{ translations.AllProducts }}
					</span>
				</td>
				<td class="prices-view-js">
					{% if coupon.Type == 0 -%}
						{{coupon.Discount | Normalize}} %
					{% elseif coupon.Type == 1 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 2 -%}
						{{translations.FreeDelivery}}
					{% elseif coupon.Type == 3 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 4 -%}
						{{coupon.Discount | Normalize}} %
					{% endif -%}
				</td>
				{% if anyMinValue -%}
				<td class="prices-view-js">
					{{ coupon.ProductsMinimumTotalValue | ToPrice }} {{currencyExt}}
				</td>
				{% endif -%}
			</tr>
		{% endif -%}
		</tbody>
	</table>
</div>

`